// URL convention: {tenant}-{app}.saawree.com  (e.g. ho-mfg.saawree.com)
// Bare hosts (mfg.saawree.com, localhost, IPs) fall back to REACT_APP_DEFAULT_TENANT.
export function getTenantFromHost(): string {
  const host = window.location.hostname;
  const isIp = /^\d+\.\d+\.\d+\.\d+$/.test(host);
  const parts = host.split('.');

  if (!isIp && parts.length >= 3) {
    const first = parts[0];
    const dashIdx = first.indexOf('-');
    if (dashIdx > 0) {
      return first.slice(0, dashIdx);
    }
  }
  return process.env.REACT_APP_DEFAULT_TENANT ?? 'ho';
}
